/**
 * Injective encoding for multi-part data-testid anchors.
 *
 * Pinflow resolves a saved testid with a global `document.querySelector`, so
 * anchors built from several authored components (field_key + option value,
 * field_key + prompt_id) must be collision-free even when the components
 * themselves contain the join delimiter. A plain `-` join is not injective:
 * ("ab-c", "d") and ("ab", "c-d") both yield "ab-c-d".
 *
 * Escaping makes the join injective: `%` → `%25` first, then `-` → `%2D`.
 * Escaped parts contain no raw `-`, so the delimiter is unambiguous, and the
 * %-escape is itself reversible. Typical snake_case keys and values pass
 * through unchanged, keeping anchors human-readable.
 */
export function testAnchorPart(part: string): string {
  return part.replace(/%/g, '%25').replace(/-/g, '%2D');
}

/** Joins already-meaningful parts into one anchor suffix, injectively. */
export function testAnchorJoin(...parts: string[]): string {
  return parts.map(testAnchorPart).join('-');
}
